import graphql__45475a8d017d83fe4654 from "./__generated__/DeleteBankTransactionRuleDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useRelayEnvironment} from "react-relay/hooks";
import {useIntl} from "react-intl";
import Section from "../form/Section";
import FormDialog from "./FormDialog";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import type {DeleteBankTransactionRuleDialogMutation} from "./__generated__/DeleteBankTransactionRuleDialogMutation.graphql";

type Props = {
    rule: {
        id: string
        containedText: string
    }
    onClose: (changed: boolean) => void
}

const DeleteBankTransactionRuleDialog: React.FC<Props> = ({rule, onClose}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = () => {
        commitMutationWithErrorHandling<DeleteBankTransactionRuleDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__45475a8d017d83fe4654,
                variables: {input: {id: rule.id}},
                onCompleted: (_, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    onClose(true);
                },
                onError: (error) => {
                    console.error(error);
                    onClose(false);
                },
            },
            addError,
            {customErrorMessage: intl.formatMessage({id: 'errors.failedToRemoveBankTransactionRule'})}
        );
    };

    return (
        <FormDialog handleCloseDialog={() => onClose(false)}
                    handleSubmission={handleSubmission}
                    initialValues={{}}
                    headline={intl.formatMessage({id: 'dialog.DeleteBankTransactionRuleDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'button.delete'})}
                    submitButtonVariant="danger">
            <Section>
                <p className="text-sm text-gray-600">
                    {intl.formatMessage({id: 'dialog.DeleteBankTransactionRuleDialog.confirmMessage'}, {text: rule.containedText})}
                </p>
            </Section>
        </FormDialog>
    );
};

export default DeleteBankTransactionRuleDialog;
